import React, { memo } from 'react'
import { useSelector } from 'react-redux';
import ReactPlayer from 'react-player'
import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateVideoDuration, updateVideoProgress } from '../../../../redux/slices/userActivity';


function Video({ playerRef, onProgress, video_url,video }) {
   // const { video, } = useSelector((state) => state.duonutSettings.settings);
   const { videoDuration, seekToDuration, isVideoPlaying } = useSelector((state) => state.userActivity);

   const dispatch = useDispatch()

   const onDuration = (res) => {
      // console.log('onDuration', res);
      if (res === null) return
      if (videoDuration > 0) return
      let duration = Math.floor(res)
      dispatch(updateVideoDuration({ videoDuration: duration }))
   }

   const handleLoadedMetadata = () => {
      const video = playerRef.current;
      if (!video) return;
      dispatch(updateVideoDuration({ videoDuration: video.duration }))
   };

   let source = ''
   if (video_url !== null && video_url !== undefined) {
      source = video_url
   } else if (typeof video === 'string') {
      source = video
   } else {
      if (video) {
         source = URL.createObjectURL(video)
      }
   }
   // console.log('playerRef', playerRef.current);

   return (
      <>
         {
            video_url !== null && video_url !== undefined ?
               <ReactPlayer
                  ref={playerRef}
                  width='100%'
                  height='100%'
                  url={video_url}
                  // url={URL.createObjectURL(video)}
                  controls={true}
                  onDuration={onDuration}
                  onProgress={onProgress}
                  playing={isVideoPlaying}
               /> : video ?

                  // <video width="600" height="500" controls ref={playerRef}
                  //    onLoadedMetadata={handleLoadedMetadata} >
                  //    <source src={source} type="video/mp4" />
                  // </video> 
                  <ReactPlayer
                     ref={playerRef}
                     width='100%'
                     height='100%'
                     url={source}
                     // url={URL.createObjectURL(video)}
                     controls={true}
                     onDuration={onDuration}
                     onProgress={onProgress}
                     playing={isVideoPlaying}
                  // controls={false}
                  // url={video}
                  // playing={true}
                  />
                  : <></>
         }

      </>
   )
}

// export default Video
export default memo(Video)